<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">DO Reference</label>
        <vs-input
          class="w-full"
          v-model="doReference"
          placeholder="Enter DO reference"
          @keyup.enter="searchDOPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchDOPreview"
          :disabled="doReference == ''"
        >
          Next
        </vs-button>
      </div>
    </div>

    <!-- Mode Tabs -->
    <vs-tabs class="mt-5" v-model="activeModeTab" v-if="showModeTabs">
      <vs-tab label="TV (Pack ID)" />
      <vs-tab label="Bracket (Qty)" />
    </vs-tabs>

    <!-- TV (Pack ID) Input -->
    <div class="vx-row mt-4" v-if="activeModeTab === 0 && showModeTabs">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Pack ID</label>
        <vs-input
          class="w-full"
          v-model="packId"
          placeholder="Enter Pack ID"
        />
      </div>
    </div>

    <!-- Bracket (Qty) Input -->
    <div class="vx-row mt-4" v-if="activeModeTab === 1 && showModeTabs">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Qty</label>
        <vs-input
          class="w-full"
          v-model="qty"
          type="number"
          placeholder="Enter quantity"
        />
      </div>
    </div>

    <!-- Process Button -->
    <div class="vx-row mt-5" v-if="showModeTabs">
      <div class="vx-col md:w-1/4 w-full">
        <vs-button
          color="primary"
          @click="submitCancelGI"
          :disabled="!canSubmit || isSubmitting"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Result Section -->
    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col md:w-full w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Cancel GI</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">DO REFERENCE</span>
            </div>
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">OLD WAREHOUSE</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">NEW WAREHOUSE</span>
            </div>
          </div>
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.do_reference }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.old_warehouse_id }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.new_warehouse_id }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:1px solid #ddd;background:#f0f0f0;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Details Deleted: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.details_deleted }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Transactions Deleted: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.transactions_deleted }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Details Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.details_updated }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Transactions Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.transactions_updated }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:1px solid #ddd;background:#f8f8f8;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Inventories Updated: </span>
              <span style="font-size:14px;">{{ result.inventories_updated }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Inventories Created: </span>
              <span style="font-size:14px;">{{ result.inventories_created }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      doReference: "",
      showModeTabs: false,
      activeModeTab: 0,
      packId: "",
      qty: "",
      isSubmitting: false,
      result: null,
    };
  },
  computed: {
    canSubmit() {
      if (this.activeModeTab === 0) {
        return this.packId !== "";
      }
      return this.qty !== "" && this.qty > 0;
    },
  },
  watch: {
    isLoading: function () {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    searchDOPreview() {
      // Placeholder - endpoint preview belum ada
      this.showModeTabs = true;
      this.packId = "";
      this.qty = "";
    },

    submitCancelGI() {
      if (this.activeModeTab === 0 && this.packId == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Pack ID is required",
        });
        return false;
      }

      if (this.activeModeTab === 1 && (this.qty == "" || this.qty <= 0)) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Qty must be greater than 0",
        });
        return false;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "Konfirmasi Cancel GI",
        text:
          this.activeModeTab === 0
            ? `Apakah kamu yakin ingin membatalkan Good Issue untuk TV dengan Serial Number "${this.packId}" pada DO "${this.doReference}"?`
            : `Apakah kamu yakin ingin membatalkan Good Issue untuk Bracket dengan jumlah ${this.qty} pada DO "${this.doReference}"?`,
        acceptText: "Ya, Process",
        accept: () => {
          this.isSubmitting = true;
          this.isLoading = true;

          const payload = {
            do_reference: this.doReference,
          };

          if (this.activeModeTab === 0) {
            payload.pack_id = this.packId;
          } else {
            payload.qty = this.qty;
          }

          this.$http
            .post("support/outbound/deliveryorder/cancel-gi", payload)
            .then((res) => {
              this.isLoading = false;
              this.isSubmitting = false;
              this.result = res.data.data;
              this.$vs.notify({
                color: "success",
                title: "Success",
                iconPack: "feather",
                icon: "icon-check",
                text: res.data.message || "Cancel GI berhasil diproses.",
              });
            })
            .catch((error) => {
              this.isLoading = false;
              this.isSubmitting = false;
              this.$emit("error", error);
            });
        },
      });
    },
  },
};
</script>
